import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

function GoogleCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      console.log("1. GoogleCallback iniciado");
      console.log("2. searchParams completos:", window.location.search);
      
      // Pegar o code da URL
      const code = searchParams.get("code");
      const error = searchParams.get("error");

      console.log("3. code:", code);
      console.log("4. error:", error);

      // Se houver erro do Google
      if (error) {
        console.log("5. Erro do Google detectado");
        toast.error("Erro ao autenticar com Google");
        navigate("/login");
        return;
      }

      // Se não tiver code
      if (!code) {
        console.log("6. Code não encontrado!");
        toast.error("Código de autenticação inválido");
        navigate("/login");
        return;
      }

      console.log("7. Chamando endpoint do Xano...");
      
      try {
        // Chamar o endpoint do Xano
        const url = `https://api.sobevenda.com.br/api-proxy/affiliate/auth/google/callback?code=${code}`;
        console.log("8. URL completa:", url);
        
        const res = await fetch(url);
        
        console.log("9. Response status:", res.status);

        console.log("9. Response status:", res.status);

        if (!res.ok) {
          console.log("10. Response não OK:", res.status, res.statusText);
          throw new Error("Erro ao processar login");
        }

        const data = await res.json();
        console.log("11. Data recebido:", data);

        // Salvar token no localStorage
        localStorage.setItem("sobevenda_token", data.authToken);
        console.log("12. Token salvo no localStorage");

        // Mostrar mensagem de sucesso
        toast.success("Login realizado com sucesso!");

        // Redirecionar para dashboard
        console.log("13. Redirecionando para dashboard...");
        navigate("/dashboard");
      } catch (err) {
        console.error("14. Erro no callback:", err);
        setError(err.message);
        toast.error("Erro ao fazer login com Google");
        
        // Redirecionar para login após 2 segundos
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap');
        
        .callback-container {
          font-family: 'Outfit', sans-serif;
        }
        
        .spinner {
          border: 4px solid rgba(59, 130, 246, 0.1);
          border-left-color: #3b82f6;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <div className="callback-container text-center">
        {!error ? (
          <>
            <div className="spinner mx-auto mb-6"></div>
            <h2 className="text-2xl font-bold text-slate-800 mb-2">
              Autenticando com Google
            </h2>
            <p className="text-slate-600">
              Aguarde enquanto processamos seu login...
            </p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-slate-800 mb-2">
              Erro ao autenticar
            </h2>
            <p className="text-slate-600 mb-4">{error}</p>
            <p className="text-sm text-slate-500">
              Redirecionando para a página de login...
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default GoogleCallback;